module.exports = __webpack_public_path__ + "img/loginlogo.b0145263.png";